import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "./categories";
import { productDetails } from "./productDetails";

const SORT_OPTIONS = { sensitivity: "base", numeric: true };

export function useCatalog() {
  const { t, i18n } = useTranslation();

  return useMemo(
    () =>
      categories.map((category) => ({
        ...category,
        name: t(`catalog.${category.id}.name`),
        products: category.products
          .map((product) => {
            const detail = productDetails[product.id];
            const language = i18n.language.split("-")[0];
            return {
              ...product,
              name: t(`catalog.${category.id}.products.${product.id}.name`),
              description: detail?.[language] || detail?.en || "",
              image: `${process.env.PUBLIC_URL}/products/${product.id}.jpg`,
            };
          })
          .sort(
            (a, b) =>
              a.name.localeCompare(b.name, i18n.language, SORT_OPTIONS) ||
              a.id - b.id
          ),
      })),
    [t, i18n.language]
  );
}
